import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/isWechat",
    name: "isWechat",
    component: () => import("../views/isWechat.vue"),
  },
  {
    path: "/team",
    name: "team",
    component: () => import("../views/team.vue"),
  },
  {
    path: "/team_in",
    name: "team_in",
    component: () => import("../components/team_in.vue"),
  },
  {
    path: "/zhishi",
    name: "zhishi",
    component: () => import("../views/zhishi.vue"),
  },
  {
    path: "/zhishi_in",
    name: "zhishi_in",
    component: () => import("../components/zhishi_in.vue"),
  },
  {
    path: "/xueyuan",
    name: "xueyuan",
    component: () => import("../views/xueyuan.vue"),
  },
  {
    path: "/xueyuan_in",
    name: "xueyuan_in",
    component: () => import("../components/xueyuan_in.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    component: () => import("../components/purchase.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news.vue"),
    children: [
      {
        path: "/",
        redirect: "news_in",
      },
      {
        path: "news_in",
        name: "news_in",
        component: () => import("../components/news_in.vue"),
      },
      {
        path: "news_ins",
        name: "news_ins",
        component: () => import("../components/news_ins.vue"),
      },
      {
        path: "news_detail",
        name: "news_detail",
        component: () => import("../components/news_detail.vue"),
      },
    ],
  },
  {
    path: "/course",
    name: "course",
    component: () => import("../views/CourseList.vue"),
    children: [
      {
        path: "/",
        redirect: "course_in",
    },
      {
        path: "course_in",
        name: "course_in",
        component: () => import("../components/course_in.vue"),
      },
      {
        path: "CourseDetails",
        name: "CourseDetails",
        component: () => import("../components/CourseDetails.vue"),
      },
    ],
  },
 
  {
    path: "/user",
    name: "user",
    component: () => import("../views/user.vue"),
    children: [
      {
        path: "/",
        redirect: "PersonalCenter",
      },
      {
        path: "PersonalCenter",
        name: "PersonalCenter",
        component: () => import("../components/PersonalCenter.vue"),
      },
      {
        path: "Setup",
        name: "Setup",
        component: () => import("../components/user_Setup.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    children: [
      {
        path: "/",
        redirect: "login_in",
      },
      {
        path: "login_in",
        name: "login_in",
        component: () => import("../components/login_in.vue"),
      },
      {
        path: "forgetPassword",
        name: "forgetPassword",
        component: () => import("../components/forgetPassword.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () => import("../components/register.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
